import QueryString from 'qs'

import { ACCESS_KEY, urlAPI } from '../../../urls'
import { store } from '../../store'
import { dataFetchingFinish, dataFetchingStart } from '../../slices/modalSlice'

const formatDubaiDateTime = (value?: string | null): string => {
    if (!value) return 'not set'
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return 'not set'
    return new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Dubai',
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    }).format(date)
}

const getQueryAdvertises = (unitID: number): string => {

    const queryObject = {
        filters: {
            $and: [
                {
                    Unit: {
                        id: {
                            $eq: unitID
                        }
                    }
                },
                // {
                //     Statuses: {
                //         $notContains: 'In-process'
                //     }
                // }
            ]
        },
        populate: {
            Unit: {
                fields: ['id']
            },
            User: {
                fields: ['id']
            }
        },
        fields: [
            'StartDate',
            'EndDate',
            'Duration',
            'Statuses',
            'Links',
            'createdAt'
        ]
    }

    return QueryString.stringify(queryObject, { encode: false })
}

const getQueryUserEmail = (userID: number): string => {
    const queryObject = {
        fields: ['email', 'phone', 'username'],
        populate: {
            ContactInfo: {
                fields: ['FirstName', 'FamilyName', 'Phone', 'Gender']
            },
            Settings: {
                fields: ['Company']
            }
        }
    }

    return QueryString.stringify(queryObject, { encode: false })
}


export const fetchAdvertisesForUnitForAdmin = async ( unitID: number ) => {
    try {
    store.dispatch(dataFetchingStart())
    const jwt = window.localStorage.getItem(ACCESS_KEY)
        const adsBody = {
            method: 'GET',
            collection: 'unit-advertises',
            query: getQueryAdvertises(unitID)
        }

        const adsResponse = await fetch(urlAPI, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${String(jwt)}`
            },
            body: JSON.stringify(adsBody)
        })

        if (!adsResponse.ok) throw new Error(`Advertises`)

        const adsJSON = await adsResponse.json()
        const rawAds = Array.isArray(adsJSON?.response?.data) ? adsJSON?.response?.data : []

        const ads: any[] = rawAds.map((ad: any) => ({
            advertiseID: ad.id,
            startDate: formatDubaiDateTime(ad.attributes.StartDate),
            endDate: formatDubaiDateTime(ad.attributes.EndDate),
            duration: ad.attributes.Duration,
            statuses: ad.attributes.Statuses,
            links: ad.attributes.Links,
            createdAt: formatDubaiDateTime(ad.attributes.createdAt),
            userID: ad.attributes.User?.data?.id,
            unitID: ad.attributes.Unit?.data?.id
        }))

        // check ads  and use for template Savia
        console.log(ads,"ads")
        const userIdsRaw = ads.map((a: any) => a.userID).filter(Boolean)
        const uniqueUserIds: number[] = userIdsRaw.filter((id, index, self) => self.indexOf(id) === index)
        const userIdToContactMap: Record<number, { email: string | null; agentName: string | null; agentPhone: string | null; company: string | null; gender: string | null }> = {}

        for (const userId of uniqueUserIds) {
            const userQuery = getQueryUserEmail(userId)

            const userBody = {
                method: 'GET',
                collection: 'users',
                id: userId,
                query: userQuery
            }

            const userResponse = await fetch(urlAPI, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${String(jwt)}`
            },
                body: JSON.stringify(userBody)
            })

            if (userResponse.ok) {
                const userJSON = await userResponse.json()
                console.log(userJSON,"userJSON")
                const user = userJSON?.response ?? {}
                const contactInfo = user?.ContactInfo ?? {}
                const firstName = String(contactInfo?.FirstName ?? '').trim()
                const familyName = String(contactInfo?.FamilyName ?? '').trim()
                const fullName = [firstName, familyName].filter(Boolean).join(' ').trim()
                const settings = Array.isArray(user?.Settings) ? user.Settings : []
                const company = String(settings?.[0]?.Company ?? '').trim()
                const gender = String(contactInfo?.Gender ?? '').trim()

                userIdToContactMap[userId] = {
                    email: user?.email ?? null,
                    agentName: fullName || user?.username || null,
                    agentPhone: contactInfo?.Phone ?? user?.phone ?? null,
                    company: company || null,
                    gender: gender || null
                }
            }
        }

        const result = ads.map((ad: any) => ({
            ...ad,
            email: userIdToContactMap[ad.userID]?.email ?? null,
            agentName: userIdToContactMap[ad.userID]?.agentName ?? null,
            agentPhone: userIdToContactMap[ad.userID]?.agentPhone ?? null,
            company: userIdToContactMap[ad.userID]?.company ?? null,
            gender: userIdToContactMap[ad.userID]?.gender ?? null
        }))
        console.log(result,"result")
            store.dispatch(dataFetchingFinish())
        saveResultToFile(result);
        return result
    } catch (error) {
            store.dispatch(dataFetchingFinish())
        console.error(error)
        return []
    }
}


function saveResultToFile(result : any, filename = "ads.txt") {
    const blob = new Blob([JSON.stringify(result, null, 2)], { type: "text" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
